<template>
  <div>
    <a-modal :title="title" :visible.sync="visible" @cancel="clear" @ok="submit" width="800px">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <!-- <a-row>
          <a-col :span="24">
            <a-form-model-item label="账户类型" prop="type" :labelCol="{ span: 3 }" :wrapperCol="{ span: 20 }">
              <a-select v-model="form.type" placeholder="请选择">
                <a-select-option value="1"> 主持人 </a-select-option>
                <a-select-option value="2"> 管理员 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row> -->
        <a-row>
          <a-col :span="12">
            <a-form-model-item :colon="false" label="姓名" prop="realName">
              <a-input v-model="form.realName" placeholder="姓名" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :colon="false" label="登录账号" prop="userName">
              <a-input v-model="form.userName" placeholder="登录账号" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="isAdd">
          <a-col :span="12">
            <a-form-model-item :colon="false" label="密码" prop="password">
              <a-input-password v-model="form.password" placeholder="请输入密码" :max-length="50" autocomplete="new-password" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :colon="false" label="密码确认" prop="passwordAgain">
              <a-input-password v-model="form.passwordAgain" placeholder="请再次输入密码" :max-length="50" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item :colon="false" label="选择角色" :labelCol="{ span: 3 }" :wrapperCol="{ span: 20 }">
              <a-select v-model="form.roleIds" mode="multiple" placeholder="请选择">
                <a-select-option v-for="item in roleOptions" :key="item.id">{{ item.roleName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item :colon="false" label="用户性别" prop="sex">
              <a-select v-model="form.sex" placeholder="请选择">
                <a-select-option value="1">男</a-select-option>
                <a-select-option value="0">女</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :colon="false" label="手机号码" prop="phone">
              <a-input v-model="form.phone" placeholder="手机号码" :max-length="11" ref="phone" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :colon="false" label="电子邮箱" prop="email">
              <a-input v-model="form.email" placeholder="电子邮箱" ref="email" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :colon="false" label="备注" :labelCol="{ span: 3 }" :wrapperCol="{ span: 20 }">
              <a-input v-model="form.remark" type="textarea" placeholder="备注内容"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { saveUser, updateUser } from '@/api/system/user'
import { roleList } from '@/api/system/role'

export default {
  name: 'user-edit',
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      wLabelCol: { span: 2 },
      wWrapperCol: { span: 21 },
      title: '',
      isAdd: true,
      visible: false,
      submitLoading: false,
      // 表单数据
      form: {},
      // 角色下拉框
      roleOptions: [],
      // 验证规则
      rules: {
        userName: [{ required: true, message: '登录账号不能为空', trigger: 'blur' }],
        realName: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        phone: [{ pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: '请输入正确的手机号码', trigger: 'blur' }],
        password: [
          { required: true, message: '密码不允许为空', trigger: 'blur' },
          { pattern: /^(\w){4,20}$/, message: '密码长度至少为4位，不允许输入空格', trigger: 'blur' },
        ],
        passwordAgain: [
          { required: true, message: '密码确认不允许为空', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致!'))
              } else {
                callback()
              }
            },
          },
        ],
      },
    }
  },
  methods: {
    resetForm() {
      this.form = {
        id: undefined,
        userName: '',
        realName: '',
        password: '',
        sex: undefined,
        phone: '',
        email: '',
        type: undefined,
        remark: '',
        roleIds: [],
      }
    },
    //打开编辑窗口
    open(record) {
      if (!record) {
        this.resetForm()
        this.title = '新增用户'
        this.isAdd = true
      } else {
        this.title = '编辑用户'
        this.isAdd = false
        Object.assign(this.form, record)
        this.form.sex = this.form.sex ? this.form.sex.toString() : undefined
        // this.form.type = this.form.type.toString()
        this.form.roleIds = record.roles.map(role => {
          return role.id
        })
      }
      this.visible = true
    },
    // 提交
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // this.submitLoading = true
          let form = this.form
          let param = {}
          param.id = form.id
          param.userName = form.userName
          param.realName = form.realName
          param.pwd = form.password
          param.sex = form.sex
          param.phone = form.phone
          param.email = form.email
          param.type = form.type
          param.remark = form.remark
          if (form.roleIds) {
            param.roleIds = form.roleIds.join(',')
          }
          if (this.isAdd) {
            saveUser(param).then(res => {
              this.$message.success('提交成功')
              this.visible = false
              this.$parent.dataLoad()
            })
          } else {
            updateUser(param).then(res => {
              this.$message.success('提交成功')
              this.visible = false
              this.$parent.dataLoad()
            })
          }
          this.visible = false
        }
      })
    },
    /** 查询角色下拉数据 **/
    getAllRoles() {
      roleList().then(response => {
        this.roleOptions = response.data.result
      })
    },
    clear() {
      this.resetForm()
      this.$refs['form'].clearValidate()
      this.visible = false
    },
  },
  created() {
    this.resetForm()
    this.getAllRoles()
  },
}
</script>
<style lang="scss"></style>
